export const osDetect = () => {
  const userAgent = window.navigator.userAgent;
  let os = "";

  if (userAgent.indexOf("Win") != -1) os = "Windows";
  if (userAgent.indexOf("Mac") != -1) os = "macOS";
  if (userAgent.indexOf("iPhone") != -1) os = "iOS";
  if (userAgent.indexOf("iPad") != -1) os = "iOS";

  return os;
};


export function initAppBannerClose() {
  document.querySelectorAll(".po-install-app-banner").forEach((appBanner) => {

    const os = osDetect();

    if (os === "iOS" || os === "macOS") {
      const osNameEl = appBanner.querySelector('.po-install-app-banner__os-name-detail')
      if(osNameEl) {
        osNameEl.innerHTML = os
      }
      appBanner.classList.add("po-install-app-banner_visible")
    }
  })

  document
    .querySelectorAll('.po-install-app-banner__close')
    .forEach((button) => {
      
      button.addEventListener('click', function () {
        const banner = this.closest('.po-install-app-banner');
        if (!banner) return;

        const height = banner.offsetHeight + 'px';
        banner.style.height = height;
        banner.style.transition = 'height 0.4s ease, opacity 0.2s ease';
        banner.style.overflow = 'hidden';

        requestAnimationFrame(() => {
          banner.style.height = '0px';
          banner.style.opacity = '0';
        });

        banner.addEventListener(
          'transitionend',
          () => {
            banner.style.display = 'none';
          },
          { once: true }
        );
      });
    });
}
